import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const DAM_URL = `${domain}/api/dam`;

export const damApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllBreaks: builder.query({
      query: () => ({
        url: `${DAM_URL}/break`,
      }),
    }),
    getAllSchedules: builder.query({
      query: () => ({
        url: `${DAM_URL}/schedule`,
      }),
    }),
  }),
});

export const { useGetAllBreaksQuery, useGetAllSchedulesQuery } =
  damApiSlice;
